import ReactDOM from 'react-dom'
import { ThemeProvider as StyledThemeProvider } from 'styled-components'
import { CssBaseline, ThemeProvider as MuiThemeProvider, StyledEngineProvider } from '@mui/material'
import { BrowserRouter } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import { BrowserTracing } from '@sentry/tracing'
import { Settings } from 'luxon'

import { App } from './components/App/App'
import { theme } from './theme'

const SENTRY_DSN = process.env.REACT_APP_MP_SENTRY_DSN
const SENTRY_ENVIRONMENT = process.env.REACT_APP_MP_SENTRY_ENVIRONMENT

Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [new BrowserTracing()],
    enabled: !!SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
})

Settings.defaultLocale = 'de'

ReactDOM.render(
    <>
        <CssBaseline />
        <StyledEngineProvider injectFirst>
            <MuiThemeProvider theme={theme}>
                <StyledThemeProvider theme={theme}>
                    <BrowserRouter>
                        <App />
                    </BrowserRouter>
                </StyledThemeProvider>
            </MuiThemeProvider>
        </StyledEngineProvider>
    </>,
    document.getElementById('root'),
)
